"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

function defaultSelector(state) {
  return state.intl;
}

var mapStateToProps = function mapStateToProps(state, _ref) {
  var _ref$intlSelector = _ref.intlSelector,
      intlSelector = _ref$intlSelector === void 0 ? defaultSelector : _ref$intlSelector;
  return intlSelector(state);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, null, null, {
  pure: false
})(_reactIntl.IntlProvider);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-intl-redux/lib/components/IntlProvider.js
// module id = 234
// module chunks = 0